export default "__VITE_ASSET__Dqdg7ezE__"